import { styled } from 'solid-styled-components';
import theme from '../../style/theme';

// const redLineStyles = `
//     &::before {
//         content: '';
//         position: absolute;
//         top: 0;
//         left: 0;
//         width: 0.6rem;
//         height: 100%;
//         background-color: ${theme.palette.pink};
//         transform: translate(-50%, 0);
//         z-index: -1; /* Places the pseudo-element behind the container */

//         ${theme.containerQueries.mobileMax} {
//             width: 0.5rem;
//         }

//     }

//     &::after {
//         content: '';
//         position: absolute;
//         top: 0;
//         left: 0;
//         width: 2.5rem;
//         height: 2.5rem;
//         background-color: ${theme.palette.white};
//         border: 0.35rem solid ${theme.palette.pink};
//         border-radius: 100%;
//         transform: translate(calc(-50%), 0);
//         z-index: -1; /* Places the pseudo-element behind the container */

//         ${theme.containerQueries.mobileMax} {
//             height: 2rem;
//             width: 2rem;
//         }

//     }
// `;

export const StyledCurriculumContainer = styled.div`
    display: flex;
    flex-direction: column;
    padding-top: 0.25rem;
    padding-bottom: 4rem;
/*     padding-left: 3rem;
    margin-left: 1rem; */
    position: relative;

    &:last-child {
        padding-bottom: 0;
        margin-bottom: 4rem;

            &::before {
                border-bottom-left-radius: 0.75rem;
                border-bottom-right-radius: 0.75rem;
            }
    }


    ${theme.containerQueries.mobileMax} {
        /* padding-left: 2.5rem; */
        margin-left: 0;
    }

`;
// ${redLineStyles}

export const StyledCoursePathsContainer = styled.div`
    container-type: inline-size;
    margin-bottom: 1rem;
    margin-top: 3rem;
`;

export const StyledCoursePathGrid = styled.div`
        display: grid;
        grid-template-rows: auto;
        height: fit-content;
        column-gap: ${theme.grid.gapSizeTabletSmall}rem;
        row-gap: ${theme.grid.gapSizeTabletSmall}rem;

        grid-template-columns:
            repeat(${3}, 1fr);


        @container (max-width: ${760}px) {
            grid-template-columns:
                repeat(${2}, 1fr);
        }

        @container (max-width: ${550}px) {
            grid-template-columns:
                repeat(${1}, 1fr);
        }
`;

export const ExpandableContainerWrapper = styled.div`
    width: 100%;
    min-width: 220px;

    ${theme.mediaQueries.desktopLargeMax} {
        max-width: 270px;
        width: 100%;
    }

    ${theme.mediaQueries.tabletMaxOriginal} {
        max-width: 300px;
    }
`;


export const StyledCourseCategoryMenuContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin-block: 2rem;
`;

export const StyledCourseCategoryMenuContainerInner = styled.div`
    width: 100%;
    max-width: 38rem;
`;

export const StyledMenuItemsList = styled.ul`
    border-top: 1px solid ${theme.palette.darkGray};
    margin-inline: 0.5rem;
    padding-block: 1.8rem;
`;

export const StyledMenuItem = styled.li`
    padding-block: 0.9rem;
`;

export const StyledMenuItemButton = styled.button<{ disabled?: boolean }>`
    display: flex;
    cursor: ${p => p.disabled ? 'not-allowed' : 'pointer'};
    color: ${theme.palette.darkGray};
    &:hover {
        ${p => p.disabled ? '' : `color: ${theme.palette.pink};`}
    }
`;


